import {
  DELETE_LISTED_DATA,
  DELETE_LISTED_DATA_SUCCESS,
  DELETE_LISTED_DATA_FAILURE,
  SEND_LISTED_DATA,
  SEND_LISTED_DATA_SUCCESS,
  SEND_LISTED_PRICE_DATA_SUCCESS,
  SEND_LISTED_DATA_FAILURE,
  POST_LISTED_DATA,
  POST_LISTED_DATA_SUCCESS,
  POST_LISTED_PRICE_DATA_SUCCESS,
  POST_LISTED_DATA_FAILURE,
  CONVERT_AUDIO_GUIDES_PRICES,
  CONVERT_AUDIO_GUIDES_PRICES_FAILURE,
} from '../../constants/ActionTypes';

export default function publishingListedReducer(state, action) {
  let nextPriceLevels = [];

  switch (action.type) {
    case DELETE_LISTED_DATA:
      return {
        ...state,
        isSaving: true,
        isSaved: false,
      };

    case DELETE_LISTED_DATA_SUCCESS:
      return {
        ...state,
        [action.attribute]: state[action.attribute].filter(
          (x) => x.id !== action.id
        ),
        isSaving: false,
        isSaved: true,
        isNotSaved: false,
      };

    case DELETE_LISTED_DATA_FAILURE:
      return {
        ...state,
        isSaving: false,
        isSaved: false,
        errors: [...state.errors, ...action.errors],
        isNotSaved: true,
      };

    case SEND_LISTED_DATA:
      return {
        ...state,
        isSaving: true,
        isSaved: false,
      };

    case SEND_LISTED_DATA_SUCCESS:
      return {
        ...state,
        [action.attribute]: state[action.attribute].map((x) =>
          x.id === action.data.id ? action.data : x
        ),
        isSaving: false,
        isSaved: true,
        isNotSaved: false,
      };

    case SEND_LISTED_PRICE_DATA_SUCCESS:
      nextPriceLevels = state.priceLevels.some(
        (plv) => plv.id === action.data.id
      )
        ? state.priceLevels.map((pl) =>
            pl.id === action.data.id ? action.data : pl
          )
        : [...state.priceLevels, action.data];

      return {
        ...state,
        receivedPublishData: {
          ...state.receivedPublishData,
          [action.attribute]: nextPriceLevels
            .map((pl) => pl.price)
            .reduce((a, b) => a + b),
        },
        priceLevels: nextPriceLevels,
        isSaving: false,
        isSaved: true,
        isNotSaved: false,
      };

    case SEND_LISTED_DATA_FAILURE:
      return {
        ...state,
        isSaving: false,
        isSaved: false,
        errors: [...state.errors, ...action.errors],
        isNotSaved: true,
      };

    case POST_LISTED_DATA:
      return {
        ...state,
        isSaving: true,
        isSaved: false,
      };

    case POST_LISTED_DATA_SUCCESS:
      return {
        ...state,
        [action.attribute]: [...state[action.attribute], action.data],
        isSaving: false,
        isSaved: true,
        isNotSaved: false,
      };

    case POST_LISTED_PRICE_DATA_SUCCESS:
      return {
        ...state,
        receivedPublishData: {
          ...state.receivedPublishData,
          [action.attribute]: action.data.price,
        },
        priceLevels: [...state.priceLevels, action.data],
        isSaving: false,
        isSaved: true,
        isNotSaved: false,
      };

    case POST_LISTED_DATA_FAILURE:
      return {
        ...state,
        isSaving: false,
        isSaved: false,
        errors: [...state.errors, ...action.errors],
        isNotSaved: true,
      };

    case CONVERT_AUDIO_GUIDES_PRICES:
      return {
        ...state,
        isSaving: true,
        isSaved: false,
        isNotSaved: false,
      };

    case CONVERT_AUDIO_GUIDES_PRICES_FAILURE:
      return {
        ...state,
        isSaving: false,
        errors: [...state.errors, ...action.errors],
        isNotSaved: true,
      };

    default:
      return state;
  }
}
